import { actionConstants } from '../actions/actionConstants';

const initState = {
  loading: false,
  isSubmitting: false,
  mobileConfigs: [],
  mobileConfig: {},
  sensors: [],
  errors: '',
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.INIT_STATE:
      return { ...initState };
    case actionConstants.START_QUERY:
      return { ...state, errors: '', loading: true };
    case actionConstants.END_QUERY:
      return { ...state, loading: false };
    case actionConstants.START_SUBMISSION:
      return { ...state, isSubmitting: true, errors: '' };
    case actionConstants.END_SUBMISSION:
      return { ...state, isSubmitting: false };
    case actionConstants.GET_MOBILE_CONFIGS_SUCCESS:
      return { ...state, mobileConfigs: action.data.items, loading: false };
    case actionConstants.GET_MOBILE_CONFIGS_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.GET_MOBILE_CONFIGS_BY_DEPT_SUCCESS:
      return { ...state, mobileConfigs: action.data, loading: false };
    case actionConstants.GET_MOBILE_CONFIGS_BY_DEPT_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.GET_MOBILE_CONFIG_SUCCESS:
      return { ...state, mobileConfig: action.data, loading: false };
    case actionConstants.GET_MOBILE_CONFIG_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.CREATE_MOBILE_CONFIG_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.CREATE_MOBILE_CONFIG_FAILURE:
      return { ...state, isSubmitting: false, errors: action.data };
    case actionConstants.EDIT_MOBILE_CONFIG_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.EDIT_MOBILE_CONFIG_FAILURE:
      return { ...state, isSubmitting: false, errors: action.data };
    case actionConstants.DELETE_MOBILE_CONFIG_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.DELETE_MOBILE_CONFIG_FAILURE:
      return { ...state, isSubmitting: false, errors: action.data };
    case actionConstants.SENSORS_BY_MOBILE_CONFIG_SUCCESS:
      return { ...state, sensors: action.data, loading: false };
    case actionConstants.SENSORS_BY_MOBILE_CONFIG_FAILURE:
      return { ...state, errors: action.data, loading: false };
    case actionConstants.CONFIG_MOBILE_SENSORS_SUCCESS:
      return { ...state, isSubmitting: false };
    case actionConstants.CONFIG_MOBILE_SENSORS_FAILURE:
      return { ...state, isSubmitting: false, errors: action.data };
    default:
      return state;
  }
};
